<template>
  <footer class="footer mt-5">
    <div class="container">
      <!-- Logo centré au-dessus des sections -->
      <div class="logo-wrapper">
        <LogoFooter class="footer-logo" />
      </div>

      <!-- Grille du footer -->
      <div class="footer-grid">
        <!-- Section Services ou Ressources -->
        <div class="footer-section services">
          <h4 class="footer-title">Nos Services</h4>
          <p>
            <nuxt-link to="/services/formations" class="footer-link"
              >Formations</nuxt-link
            >
          </p>
          <p>
            <nuxt-link to="/services/creations" class="footer-link"
              >Conception</nuxt-link
            >
          </p>
          <p>
            <nuxt-link to="/services/support" class="footer-link"
              >Support</nuxt-link
            >
          </p>
        </div>

        <!-- Section Réseaux Sociaux -->
        <div class="footer-section social-media-section">
          <h4 class="footer-title">Réseaux sociaux</h4>
          <!-- Inclure les icônes des réseaux sociaux -->
          <div class="social-media">
            <a
              :href="links.linkedin"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              :href="links.instagram"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              :href="links.facebook"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook"></i>
            </a>
            <a
  :href="links.youtube"
  target="_blank"
  rel="noopener"
  aria-label="YouTube"
>
  <i class="fab fa-youtube"></i>
</a>
<a
  :href="links.tiktok"
  target="_blank"
  rel="noopener"
  aria-label="TikTok"
>
  <i class="fab fa-tiktok"></i>
</a>

<a
  :href="links.pinterest"
  target="_blank"
  rel="noopener"
  aria-label="Pinterest"
>
  <i class="fab fa-pinterest"></i>
</a>

          </div>
        </div>

        <!-- Section Liens utiles -->
        <div class="footer-section">
          <h4 class="footer-title">Liens utiles</h4>
         
          <p>
            <nuxt-link to="/contribute" class="footer-link"
              >Partagez vos connaissances sur Longoka</nuxt-link
            >
          </p>
            <p>
            <nuxt-link to="/terms" class="footer-link">Conditions générales d'utilisation</nuxt-link>
          </p>
          <p>
            <nuxt-link to="/privacy" class="footer-link"
              >Mentions Légales</nuxt-link
            >
          </p>
         
          <p>
            <nuxt-link to="/documentation" class="footer-link"
              >Documentation</nuxt-link
            >
          </p>
          <p>
  <nuxt-link to="/faq" class="footer-link">FAQ</nuxt-link>
</p>
<p>
  <nuxt-link to="/shop" class="footer-link">Boutique Longoka</nuxt-link>
</p>
<p>
  <nuxt-link to="/sitemap" class="footer-link">Plan du site</nuxt-link>
</p>

          <p>
  <button @click="resetConsent" class="footer-link footer-cookie-btn link-underline-light" aria-label="Modifier vos préférences de cookies">
    ⚙️ Préférences cookies
  </button>
</p>

            <p>
            <nuxt-link to="/contact" class="footer-link"
              >Contactez-nous</nuxt-link
            >
          </p>
        
        </div>

        <!-- Section Partenaires -->
        <div class="footer-section partners">
          <h4 class="footer-title">Nos Partenaires</h4>
          <p>
            <a
              href="https://lexikongo.fr"
              class="footer-link"
              target="_blank"
              rel="noopener"
              ><span class="fw-bold">Lexikongo</span> <br />
              <small>Dictionnaire Kikongo - Français - Anglais</small></a
            >
          </p>
      

          <p>
            <a
              href="https://fr.wikikongo.net/index.php/Accueil"
              class="footer-link"
              target="_blank"
              rel="noopener"
              ><span class="fw-bold">Wikikongo</span> <br />
              <small>Encyclopédie libre</small></a
            >
          </p>
          <p>
            <a
              href="https://goseneye.com"
              class="footer-link"
              target="_blank"
              rel="noopener"
              ><span class="fw-bold">Gosen'Eye</span> <br />
              <small>Vidéaste, Réalisateur</small></a
            >
          </p>
              <p>
            <a
              href="https://cyrille-plomberie.fr"
              class="footer-link"
              target="_blank"
              rel="noopener"
              ><span class="fw-bold">Ambès Cyrille Plomberie</span> <br />
              <small>Installation, Maintenance, Réparation</small></a
            >
          </p>
                <p>
            <a
              href="https://www.keratotherapeute-bordeaux.com"
              class="footer-link"
              target="_blank"
              rel="noopener"
              ><span class="fw-bold">Mélanie Decarsin</span> <br />
              <small>Kératothérapeute et Facialiste</small></a
            >
          </p>
        </div>
      </div>

      <!-- Section Copyright et crédits -->
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} Longoka - Contenus protégés</p>
        <p>
          Site conçu et maintenu par :
          <a
            class="footer-link"
            href="https://artfulbatinacreativestudios.fr"
            target="_blank"
            >Artful Batina Creative Studios</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useCookie } from '#app'

import { useCookieConsentStore } from '@/composables/useCookieConsentStore'
const { resetConsent } = useCookieConsentStore()

const currentYear = new Date().getFullYear();

const links = {
  linkedin: "https://www.linkedin.com/in/",
  instagram: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/profile.php?id=61574050318886",
  youtube: "https://www.youtube.com/@LongokaOfficial",
  pinterest: "https://www.pinterest.com/",
  tiktok: "https://www.tiktok.com/"
};

</script>

<style scoped>
.footer {
  background-color: #169a7a;
  color: #ffffff;
  padding: 40px 0;
  text-align: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Section pour le logo centré */
.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.footer-logo {
  max-width: 50%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.footer-cookie-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: #ffffff;
}

.footer-cookie-btn:hover {
  color: #292929;
  text-decoration: none;
}

/* Pour les écrans plus petits, réduire légèrement la taille du logo */
@media (max-width: 768px) {
  .footer-logo {
    max-width: 60%;
  }
}

/* Grille du footer */
.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  justify-items: center;
  margin-bottom: 30px;
}

/* Pour les écrans moyens et grands */
@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.footer-section {
  width: 100%;
  text-align: center;
}

.footer-title {
  margin-bottom: 20px;
  font-size: 1.4em;
  color: #292929;
}

.footer-link,
.fa {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover,
.social-media a:hover {
  color: #292929;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.social-media a {
  color: #ffffff;
  font-size: 24px;
  transition: color 0.3s;
}

.footer-bottom {
  border-top: 1px solid #ffffff;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.footer-bottom p {
  margin: 0;
}
i {
  color: #fff;
}
@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
